// extracted by mini-css-extract-plugin
export default {"northmillSyncTabs":"northmill_northmillSyncTabs__gQcN3"};